.slider {
  width: 100%;
  position: relative;
  cursor: pointer;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
  color: var(--tuna-palette-primary-main);
  height: 4px;
  display: inline-flex;
  align-items: center;
  padding: 13px 0;
  box-sizing: content-box;
}

.control {
  width: 100%;
  height: 4px;
  position: relative;
}

.rail {
  display: block;
  width: 100%;
  height: 4px;
  border-radius: var(--tuna-shape-radius-sm);
  background-color: currentColor;
  opacity: 0.38;
}

.track {
  display: block;
  height: 4px;
  border-radius: var(--tuna-shape-radius-sm);
  background-color: currentColor;
  opacity: 1;
}

.thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: currentColor;
  box-shadow: var(--tuna-shadow-2);
}

.thumb:hover {
  box-shadow: 0 0 0 8px color-mix(in oklch, currentColor 16%, transparent);
}

.thumb:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.valueLabel {
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  line-height: 1;
  padding: 2px 6px;
  border-radius: var(--tuna-shape-radius-sm);
  background-color: var(--tuna-palette-grey-700);
  color: var(--tuna-palette-grey-50);
  white-space: nowrap;
  pointer-events: none;
}

.slider[data-disabled] {
  opacity: 0.38;
  pointer-events: none;
  cursor: default;
}
